import * as React from 'react';

export class ReorderButton extends React.Component<{ nItems: number }, any> {
    render() {
        if (this.props.nItems > 1) {
            return (
                <span
                    className="dx-icon-dragvertical"
                    style={{ cursor: 'grab', fontSize: 'x-large' }}
                    title={' Reorder '}
                ></span>
            );
        } else {
            return null;
        }
    }
}
